// Module
var code = "<daterange-picker (rangeChanged)=\"selectPeriod($event)\" [opensOption]=\"opensOption\" [initialRange]=\"range\" [visibleRanges]=\"periods\"> </daterange-picker>";
// Exports
module.exports = code;